<template>
    <section>
        <div class="future-boxss">
            <!-- 左边过渡云 -->
            <div class="cloud-left"></div>
            <swiper :options="swiperOption1" ref="activeSwiper">
                <!-- 近期活动 -->
                <swiper-slide class="future-box">
                    <div class="future-content" ref="future_content">
                        <div class="titles mic-semblod">{{ $t('近期活动') }}</div>
                        <!-- 时间轴 -->
                        <Timeline :dataList="timeline_act_list" :timelineWidth="timelineWidth" :firstDay="firstDay"
                            :lastDay="lastDay" />

                        <!-- 列表数据 -->
                        <div class="future-lists df fww">
                            <div class="list-box" :class="'list' + (index + 1)" v-for="(item, index) in recent_act_list"
                                @click="handleLink(item)">
                                <div class="imgs">
                                    <el-image :src="item.ta_thumb" style="width: 100%;height: 100%;" fit="cover">
                                        <div slot="error" class="image-slot">
                                            <img src="@/assets/images/news-default.png" alt="">
                                        </div>
                                    </el-image>


                                    <!-- <img :src="item.ta_thumb" alt=""> -->
                                </div>
                                <div class="con">
                                    <div class="t1s mic-semblod one-text">{{ item.ta_title }}</div>
                                    <div class="desc one-text" v-if="index < 2">{{ item.ta_desc }}</div>
                                    <div class="adds df aic jcsb">
                                        <div class="left f1 over-h">
                                            <div class="address one-text"><span class="iconfont">&#xe601;</span>
                                                {{ item.ta_city_text }}
                                            </div>
                                            <div class="date"><span class="iconfont">&#xe602;</span>
<!--                                                {{ item.ta_start_time * 1000, 'YYYY-MM-DD' | formatTime }}-->
                                                {{ item.ta_start_time }}
                                            </div>
                                        </div>
                                        <el-button type="primary" class="blue-btn ml-16" v-if="item.is_sign_up == 20">
                                          {{ $t('即将举行') }}
                                        </el-button>
                                        <el-button type="primary" class="blue-btn ml-16" v-if="item.is_sign_up == 30">
                                          {{ $t('活动报名中') }}
                                        </el-button>
                                        <el-button type="primary" class="blue-btn ml-16" v-if="item.is_sign_up == 40">
                                          {{ $t('活动进行中') }}
                                        </el-button>
                                        <el-button type="primary" class="blue-btn end ml-16" v-if="item.is_sign_up == 10">
                                          {{ $t('活动已结束') }}
                                        </el-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </swiper-slide>
                <!-- 精彩活动 -->
                <swiper-slide class="marvellous-box">
                    <div class="marvellous-content">
                        <div class="titles mic-semblod">{{ $t('精彩回顾') }}</div>
                        <div class="marvellous-lists df fww">
                            <div class="no-data pt-160" v-if="review_act_list.length == 0">
                                <img :src="require('../../../assets/images/empty_data.png')" alt="">
                                <p>{{ $t('暂无数据') }}</p>
                            </div>
                            <div class="list" v-for="(item, index) in review_act_list" @click="handleLink(item)">
                                <div class="t1s one-text"><span class="iconfont">&#xe604;</span>{{ item.tar_title }}
                                </div>
                                <div class="imgs">
                                    <el-image :src="item.tar_thumb" style="width: 100%;" fit="cover">
                                        <div slot="error" class="image-slot df aic jcc"
                                            style="width: 100%;height: 100%;">
                                            <i class="el-icon-picture-outline"></i>
                                        </div>
                                    </el-image>
                                    <!-- <img :src="item.tar_thumb" alt=""> -->
                                    <div class="address df aic">
                                        <span>{{ item.tar_city_text }}</span>
                                        <span class="date">{{ item.tar_start_time }}</span>
                                    </div>
                                </div>
                                <div class="desc tow-text">
                                    {{ item.tar_desc }}
                                </div>
                            </div>
                        </div>
                    </div>
                </swiper-slide>
            </swiper>
            <div class="cloud-right"></div>
        </div>

        <div class="activity-btns">
            <div class="more-btn">
                <el-button type="primary" class="more" @click="handleMore()">
                    {{ $t('查看更多') }}<span class="iconfont">&#xe7e2;</span>
                </el-button>
                <div class="swiper-button-prev" id="future_prev"></div>
                <div class="swiper-button-next" id="future_next"></div>
            </div>
        </div>
    </section>
</template>

<script>
// 引入swiper文件
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
// 时间轴
import Timeline from "../../../components/Timeline.vue";
import "swiper/css/swiper.css";

import { getactivityList } from "@api/home";

export default {
    components: { Swiper, SwiperSlide, Timeline },
    data() {
        return {

            swiperOption1: {
                slidesPerView: 'auto',
                navigation: {
                    nextEl: '#future_next',
                    prevEl: '#future_prev',
                },
            },
            recent_act_list: [],  //近期活动
            review_act_list: [],  //精彩活动
            timeline_act_list: [{ flog: 1 }],  //活动时间线

            timelineWidth: 0,  //时间轴宽度
            firstDay: '',
            lastDay: '',


        }
    },

    mounted() {
        this.getData();

        // 获取当月第一天和最后一天

        const now = new Date(); // 获取当前日期
        this.firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
        this.lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0); // 0 表示上一个月的最后一天

        // 使用 nextTick 确保 DOM 更新完成
        this.$nextTick(() => {
            this.timelineWidth = this.$refs['future_content'].clientWidth;
        });

    },
    methods: {


        formattedDate(date) {
            // 将原始日期字符串转换为 Date 对象
            const dateParts = date.split('-');
            // 返回格式化后的日期字符串
            return `${dateParts[0]}.${dateParts[1]}.${dateParts[2]}`;
        },

        // 查看更多
        handleMore() {

            let str = '/cn';
            let Language = localStorage.getItem('currentLanguage');  //获取本地语言
            if (Language && Language != 'zh') {
                str = '/' + Language;
            }
            this.$router.push(str + '/activity/index'); // 使用编程式导航跳转到 About 页面
            // this.$router.push('/cn/activity/index/')
        },

        // 跳转详情
        handleLink(item) {
            let str = '/cn';
            let Language = localStorage.getItem('currentLanguage');  //获取本地语言
            if (Language && Language != 'zh') {
                str = '/' + Language;
            }
            // this.$router.push(str + '/activity/info/' + item.ta_id); // 使用编程式导航跳转到 About 页面
            let target={}
            // 判断是否是精英赛
            if(item.ta_kind==30){
                target = this.$router.resolve(str + '/challenge/info/' + item.ta_id)
            }else{
                target = this.$router.resolve(str + '/activity/info/' + item.ta_id)
            }
            window.open(target.href, '_blank');
        },
        async getData() {
            let res = await getactivityList();
            if (res.status == 200) {
                this.recent_act_list = res.data.recent_act_list;
                this.review_act_list = res.data.review_act_list;

                let timelineata = res.data.timeline_act_list.map((item, index) => {
                    if (this.isDatePassed(item.ta_start_time)) {
                        item.flog = '1';
                    } else {
                        item.flog = '2';
                    }
                    return item;
                });

                timelineata.sort((a, b) => {
                    return new Date(a.ta_start_time) - new Date(b.ta_start_time);
                });


                this.timeline_act_list = JSON.parse(JSON.stringify(timelineata));
            }
        },

        isDatePassed(targetDate) {
            const now = new Date(); // 获取当前时间
            const target = new Date(targetDate); // 将目标日期转换为 Date 对象

            // 比较当前时间和目标时间
            return now > target; // 如果当前时间大于目标时间，返回 true
        }

    }
}
</script>
<style lang="scss">
.future-boxss .swiper-wrapper {
    padding-left: 80px;
    padding-bottom: 38px;
    box-sizing: border-box;
}

::v-deep() {
    .future-boxss .swiper-wrapper {
        padding-left: 80px;
        padding-bottom: 38px;
        box-sizing: border-box;
    }
}
</style>
<style lang="scss" scoped>
.swiper-wrapper {
    padding-left: 80px;
    padding-bottom: 38px;
    box-sizing: border-box;
}

::v-dee() {
    .swiper-wrapper {
        padding-left: 80px;
        padding-bottom: 38px;
        box-sizing: border-box;
    }
}

.activity-btns {
    padding: 0 80px 80px;
    text-align: center;

    .more-btn {
        position: relative;
        z-index: 66;
    }

    ::v-deep() {

        .swiper-button-prev,
        .swiper-button-next {
            top: auto;
            bottom: -4px;
            width: 43px;
            height: 43px;
            border-radius: 4px;
            background: rgb(243, 243, 243);
            transition: 'opacity' 0.36s, 'background' 0.36s;

            &:hover {
                background: #DD736D;

                &::after {
                    color: #ffffff;
                }
            }
        }

        .swiper-button-prev.swiper-button-disabled,
        .swiper-button-next.swiper-button-disabled {
            opacity: 0;
        }

        .swiper-button-prev:after,
        .swiper-button-next:after {
            font-family: "iconfont";
            font-size: 7px;
            color: #959494;
        }

        .swiper-button-next:after {
            content: "\e605";
        }

        .swiper-button-prev:after {
            content: "\e606";
        }
    }



    .more {
        min-width: 106px;
        height: 36px;
        font-size: 14px;
        color: rgb(25, 25, 25);
        background-color: #ffffff;
        box-sizing: border-box;
        border: 0.5px solid rgb(0, 0, 0);
        border-radius: 20px;
        padding: 0 16px;

        .iconfont {
            font-size: 12px;
            color: #191919;
            margin-left: 5px;
        }

        &:hover {
            border: 0.5px solid rgb(183, 37, 30);
            color: rgb(183, 37, 30);

            .iconfont {
                color: rgb(183, 37, 30);
            }
        }
    }
}

.cloud-left {
    position: absolute;
    top: 91px;
    width: 131px;
    height: 761px;
    transform: rotate(180.00deg);
    background: linear-gradient(270.00deg, rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0) 100%);
    z-index: 60;
}

.cloud-right {
    position: absolute;
    width: 80px;
    height: 761px;
    top: 49px;
    right: 0;
    background: linear-gradient(270.00deg, rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0) 100%);
    z-index: 60;
}


.titles {
    font-size: 32px;
    line-height: 36px;
    font-weight: 400;
    color: #191919;
}

.future-box {
    width: calc((100% - 73px) * 0.78);
    padding-right: 48px;
}

.future-content {}

.marvellous-box {
    // width: 1077px;
    // width: 1237px;
    width: calc(69.11vw + 160px);
    padding-right: 160px;
}

// 近期活动
.future-lists {
    .list-box {
        cursor: pointer;

        .imgs {
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }

        ::v-deep() {
            .image-slot {
                width: 100%;
                height: 100%;
            }
        }

        &:hover {
            ::v-deep() {

                // .imgs .el-image {
                //     transform: scale(1.1);
                // }
            }

            .t1s {
                color: #B7251E;
            }
        }

        .t1s {
            font-size: 24px;
            color: rgb(25, 25, 25);
            line-height: 32px;
        }

        .desc {
            font-size: 16px;
            color: rgb(89, 89, 89);
            line-height: 24px;
            font-weight: 400;
            margin-top: 3px;
        }

        .imgs {
            overflow: hidden;
        }

        ::v-deep() {
            .imgs .el-image {
                transition: all 1s;
            }
        }


        .adds {

            .address,
            .date {
                font-size: 14px;
                line-height: 24px;
                color: #777777;
                margin-top: 4px;

                .iconfont {
                    margin-right: 2px;
                    font-size: 14px;
                }
            }

            .blue-btn {
                min-width: 108px;
                height: 36px;
                background-color: #EFF4FF;
                border-radius: 32px;
                border: none;
                line-height: 36px;
                padding: 0 10px;
                font-size: 14px;
                color: #015DE1;

                &.end {
                    color: #6d7177;
                    background: #ffffff;
                    border: 1px solid #6d7177;
                }
            }
        }

        &.list1,
        &.list2 {

            width: calc(50% - 10px);
            // height: 378px;
            border-radius: 8px;
            /* 卡片阴影 */
            box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.14);
            background: rgb(255, 255, 255);
            margin-bottom: 20px;
            overflow: hidden;


            .imgs {
                width: 100%;
                // height: 240px;
                position: relative;
                padding-bottom: 50%;
                // overflow: hidden;
                ::v-deep(){
                    .el-image{
                        position: absolute;
                        left: 0;
                        top: 0;
                        width: 100%;
                        height: auto;
                        max-height: 100%;
                    }
                    .el-image__inner{
                        width: 100%;
                        height: auto;
                    }
                }
            }


            .con {
                padding: 0px 24px 14px 24px;
                margin-top: 8px;
            }


        }

        &.list2 {
            margin-left: 20px;
        }

        &.list3,
        &.list4,
        &.list5 {
            width: calc(33.333% - 13.333px);
            // height: 274px;
            border-radius: 8px;
            box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.14);
            background: rgb(255, 255, 255);
            overflow: hidden;



            .t1s {
                font-size: 16px;
            }

            .imgs {
                width: 100%;
                // height: 170px;
                padding-bottom: 50%;
                position: relative;
                ::v-deep(){
                    .el-image{
                        position: absolute;
                        left: 0;
                        top: 0;
                        width: 100%;
                        height: auto;
                        max-height: 100%;
                    }
                    .el-image__inner{
                        width: 100%;
                        height: auto;
                    }
                }

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }

            .con {
                padding: 0px 24px 8px 24px;
                margin-top: 8px;
            }
        }

        &.list4 {
            margin: 0 20px;
        }
    }
}

// 精彩活动
.marvellous-lists {
    margin-top: 25px;
    // padding-right: 80px;

    .list {
        width: calc(50% - 19px);
        // width: 520px;
        // height: 354px;
        margin-top: 21px;
        cursor: pointer;

        ::v-deep() {
            .imgs .el-image {
                transition: all 1s;
            }
        }

        &:hover {
            // ::v-deep() {
            //     .imgs .el-image {
            //         transform: scale(1.1);
            //     }
            // }
        }

        .t1s {
            color: rgb(25, 25, 25);
            font-size: 24px;
            font-weight: 400;
            line-height: 32px;

            &::after {}

            .iconfont {
                font-size: 28px;
                color: #B7251E;
                margin-right: -12px;
                position: relative;
                top: 2px;
            }
        }

        .imgs {
            width: 100%;
            // height: 240px;
            padding-bottom: 50%;
            border-radius: 8px;
            margin-top: 16px;
            overflow: hidden;
            position: relative;
            
            ::v-deep(){
                .el-image{
                    position: absolute;
                    left: 0;
                    top: 0;
                }
                .el-image__inner{
                    width: 100%;
                    height: auto;
                }

                
            }
            img {
                width: 100%;
                height: 240px;
                object-fit: cover;
            }

            .address {
                width: 100%;
                height: 54px;
                position: absolute;
                border-radius: 0px 0px 12px 12px;
                background: rgba(38, 38, 38, 0.41);
                bottom: 0;
                left: 0;
                padding-left: 21px;

                span {
                    color: #ffffff;
                    font-size: 16px;
                    font-weight: 400;
                    line-height: 20px;
                }

                .date {
                    margin-left: 12px;
                }
            }
        }

        .desc {
            color: rgb(25, 25, 25);
            font-size: 16px;
            font-weight: 290;
            line-height: 24px;
            margin-top: 16px;
        }
    }

    .list:nth-child(2n-1) {
        margin-right: 37px;
    }
}
</style>